@use '@/styles/tokens' as *;

.wrapper {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 10px;
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
  background: var(--surface-card);
  color: var(--text-primary);
  cursor: pointer;
  transition:
    background 150ms ease,
    border-color 150ms ease;

  &:hover {
    background: $color-light-brown-100;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  // Red per user stories (102117/118/119: "small red dot" active-filter indicator).
  background: $color-error-500;
}

.clear {
  padding: 0;
  border: none;
  background: transparent;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap; // a block <SearchBar> beside it would otherwise squeeze it onto two lines
  color: $color-error-500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: none;
    border-radius: 4px;
    box-shadow: var(--focus-ring);
  }
}
